import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';

import TableWithSummary from '../../../../../components/table/TableWithSummary';
import { PRODUCT_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/productConstants';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  PRODUCT_LIST_FILTER_OPTION_MODEL,
  PRODUCT_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/product/models';
import columns from './columns';
import Button from '../../../../../components/Button';
import { productActions } from '../../../../../store/modules/product';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../../../constants/service/common/utilConstants';
import './ProductAllList.scss';

const ProductAllList = ({ getList }) => {
  const dispatch = useDispatch();

  const { email } = useSelector((state) => state.app.adminInfo);
  const { list, filterOption, sortOption, searchOption, pagination, summary } = useSelector(
    (state) => state.product.productList,
  );

  const toggleModal = (data) => dispatch(productActions.toggleModal(data));
  const getProductAllListExcelDownload = (data) => dispatch(productActions.getProductAllListExcelDownload(data));
  const getProductAllFulfillmentListExcelDownload = (data) =>
    dispatch(productActions.getProductAllFulfillmentListExcelDownload(data));

  const getExcelDownload = () => {
    if (!list?.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getProductAllListExcelDownload({
      email,
      searchOption,
      filterOption,
      sortOption,
    });
  };

  const getExcelFulfillmentDownload = () => {
    if (!list?.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getProductAllFulfillmentListExcelDownload({
      email,
      searchOption,
      filterOption,
      sortOption,
    });
  };

  return (
    <div className="product-all-list">
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        head={
          <Fragment>
            <Button isRadius color="gray" text="풀필먼트 엑셀다운" onClick={getExcelFulfillmentDownload} />
            <Button
              isRadius
              color="light"
              text="할인 일괄 변경"
              onClick={() =>
                toggleModal({
                  name: 'excelBulkEditProductDiscount',
                  value: true,
                })
              }
            />
          </Fragment>
        }
        initialOption={{
          filterOption: PRODUCT_LIST_FILTER_OPTION_MODEL,
          sortOption: PRODUCT_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        getExcelDownload={getExcelDownload}
        isStriped={true}
        emptyText={PRODUCT_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        columns={(utils) =>
          columns({
            ...utils,
          })
        }
      />
    </div>
  );
};

export default ProductAllList;
